import { getListRolesQueryKey, listRoles } from '@modusign/openapi-client-user';
import { useQuery } from 'react-query';

import {
  MAX_COUNT_OF_GROUPS_PER_WORKSPACE,
  MAX_COUNT_OF_MEMBERS_PER_WORKSPACE,
  MAX_COUNT_OF_ROLES_PER_WORKSPACE,
} from '@app/features/workspaceManagement/constants';
import { adaptWorkspaceGroup, adaptWorkspaceMember } from '@app/features/workspaceManagement/types';
import {
  getListResourceRoleSubjectsQueryKey,
  listResourceRoleSubjects,
} from '@app/features/workspaceManagement/workspaceMemberInvitation/hooks/useListResourceRoleSubjects';
import getAllList from '@app/libs/getAllList';

export default function useAllRolesAndSubjects(workspaceId: string) {
  const roles = useQuery({
    queryKey: getListRolesQueryKey(workspaceId).concat('withGetAllList'),
    queryFn: () =>
      getAllList({
        limit: MAX_COUNT_OF_ROLES_PER_WORKSPACE,
        queryFn: async (offset, limit) => {
          const { count, roles } = await listRoles(workspaceId, { offset, limit });
          return {
            count,
            list: roles,
          };
        },
      }),
  });

  const resourceRoleSubjects = useQuery({
    queryKey: getListResourceRoleSubjectsQueryKey(workspaceId).concat('withGetAllList'),
    queryFn: () =>
      getAllList({
        limit:
          MAX_COUNT_OF_MEMBERS_PER_WORKSPACE > MAX_COUNT_OF_GROUPS_PER_WORKSPACE
            ? MAX_COUNT_OF_MEMBERS_PER_WORKSPACE
            : MAX_COUNT_OF_GROUPS_PER_WORKSPACE,
        queryFn: async (offset, limit) => {
          const { members, groups } = await listResourceRoleSubjects(workspaceId, {
            offset,
            limit,
          });
          return {
            count: members.count > groups.count ? members.count : groups.count,
            list: [
              ...members.members.map((m) => adaptWorkspaceMember(m)),
              ...groups.groups.map((g) => adaptWorkspaceGroup(g)),
            ],
          };
        },
      }),
  });

  return { roles, resourceRoleSubjects };
}
